module.exports = __webpack_public_path__ + "static/media/4.bda7e7f7.png";